import { TitleText } from '../orders/_components/common/TitleText';
import { Dialog, DialogTrigger, DialogContent } from '@/components/atoms/Dialog';
import TutorialTriggerButton from '@/components/molecules/TutorialTriggerButton';

import { LayoutTabSection as LayoutTab } from '../orders/_layouts/LayoutTabSection';
import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';

export const TabSection = () => {
  return (
    <LayoutTab>
      <div className="flex items-center  gap-[16px]">
        <TitleText title="상품 순위 모니터링" />
        <TutorialDialog />
      </div>
    </LayoutTab>
  );
};

export const TutorialDialog = () => {
  const isPreviewMode = useMembershipPreviewMode();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <TutorialTriggerButton
          data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
        />
      </DialogTrigger>
      <DialogContent
        noCloseBtn
        className="w-[400px] p-[30px]"
        data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
      >
        <div className="flex flex-col gap-[20px]">
          <div className="flex flex-col gap-1">
            <div className="text-gr-800 Title3S18">
              스마트스토어 상품 순위 변화를 매일 알려드려요!
            </div>
            <div className="text-gr-700 Body5M14">
              노출 순위를 매일 확인하고 판매 전략을 관리해 보세요
            </div>
          </div>
          <div className="flex flex-col gap-1">
            <div className="text-gr-800 Title3S18">원하는 키워드로 상품을 모니터링하세요 </div>
            <div className="text-gr-700 Body5M14">
              상품명과 해시태그, 원하는 키워드로 내 상품이 몇 위에 노출되는지 확인할 수 있어요
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
